/**
 * @description 判斷檔案是否為已知檔案格式
 *
 * @param extension 檔案副檔名，接受 .pdf 或 pdf
 * @returns 是否為已知檔案格式
 */
export function isExceptFileExtension(extension: string): boolean {
  const exceptFileExtensions = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.txt',
    '.zip',
    '.tif',
    '.tiff'
  ];
  return exceptFileExtensions.some(
    (item) => item.indexOf(extension.trim().toLocaleLowerCase()) > -1
  );
}
